import React from 'react';
import StudentCard from './StudentCard';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const StudentList = ({ students, pagination, onPrevPage, onNextPage }) => {
  return (
    <div>
      {/* Students Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        {students.map((student) => (
          <StudentCard key={student._id} student={student} />
        ))}
      </div>

      {/* Pagination */}
      {pagination.totalPages > 1 && (
        <div className="flex items-center justify-between bg-white rounded-lg shadow-sm border border-gray-200 px-4 py-3">
          <div className="text-sm text-gray-700">
            Showing{' '}
            <span className="font-medium">
              {(pagination.currentPage - 1) * pagination.itemsPerPage + 1}
            </span>{' '}
            to{' '}
            <span className="font-medium">
              {Math.min(
                pagination.currentPage * pagination.itemsPerPage,
                pagination.totalItems
              )}
            </span>{' '}
            of <span className="font-medium">{pagination.totalItems}</span> students
          </div>

          <div className="flex items-center space-x-2">
            <button
              onClick={onPrevPage}
              disabled={!pagination.hasPrevPage}
              className={`flex items-center px-3 py-2 rounded-md text-sm font-medium ${
                pagination.hasPrevPage
                  ? 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              }`}
            >
              <FiChevronLeft className="mr-1" />
              Previous
            </button>

            <span className="text-sm text-gray-700">
              Page {pagination.currentPage} of {pagination.totalPages}
            </span>

            <button
              onClick={onNextPage}
              disabled={!pagination.hasNextPage}
              className={`flex items-center px-3 py-2 rounded-md text-sm font-medium ${
                pagination.hasNextPage
                  ? 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              }`}
            >
              Next
              <FiChevronRight className="ml-1" />
            </button>
          </div>
        </div>
      )}

      {/* No Results */}
      {students.length === 0 && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
          <p className="text-gray-500">No students found matching your filters.</p>
        </div>
      )}
    </div>
  );
};

export default StudentList;
